export const focusRingClassName = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2';
//# sourceMappingURL=focus.js.map